module.exports = __webpack_public_path__ + "img/img-15.27dfe05f.png";